import styled from 'styled-components';

export const UserManagementContainer = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #dee2e6;
  overflow: hidden;
`;

export const UserManagementHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  border-bottom: 1px solid #dee2e6;
  background: #f8f9fa;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
    padding: 16px;
  }
`;

export const UserManagementTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: #212529;
  margin: 0;
`;

export const UserManagementActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const UserManagementButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background: white;
  color: #495057;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: #f8f9fa;
    border-color: #adb5bd;
  }
  
  &:active {
    transform: translateY(1px);
  }
`;

export const UserManagementSearch = styled.input`
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 14px;
  width: 250px;
  min-height: 44px; /* Touch-friendly height */
  
  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const UserManagementTable = styled.div`
  overflow-x: auto;
`;

export const UserManagementTableHeader = styled.div`
  display: grid;
  grid-template-columns: 50px 1fr 120px 100px 150px 120px 120px;
  gap: 16px;
  padding: 16px 24px;
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  font-size: 12px;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 8px;
    padding: 12px 16px;
  }
`;

export const UserManagementTableRow = styled.div`
  display: grid;
  grid-template-columns: 50px 1fr 120px 100px 150px 120px 120px;
  gap: 16px;
  padding: 16px 24px;
  border-bottom: 1px solid #f8f9fa;
  align-items: center;
  transition: background-color 0.2s ease;
  min-height: 60px; /* Touch-friendly row height */
  
  &:hover {
    background: #f8f9fa;
  }

  &:active {
    background: #e9ecef;
  }
  
  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 8px;
    padding: 12px 16px;
    min-height: auto;
  }
`;

export const UserManagementTableCell = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #495057;
`;

export const UserManagementAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
  color: white;
  font-weight: 600;
`;

export const UserManagementStatus = styled.span<{ $color: string }>`
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background-color: ${props => props.$color}20;
  color: ${props => props.$color};
  border: 1px solid ${props => props.$color}40;
`;

// Note: Responsive design handled via CSS media queries in global styles
